<div class="date-picker-header">
  <button
    mat-button
    #monthTrigger="matMenuTrigger"
    [matMenuTriggerFor]="month"
    (menuOpened)="onMonthMenuOpened()"
    class="month-trigger"
  >
    {{ getMonths()[getActiveMonth()] | titlecase }}

    <mat-icon matSuffix>arrow_drop_down</mat-icon>
  </button>
  <mat-menu #month="matMenu" class="month-menu" yPosition="below" xPosition="after">
    @for(month of getMonths(); track month; let idx = $index) {
    <button mat-menu-item (click)="setMonth(idx)" [class.active]="idx === getActiveMonth()">
      {{ month | titlecase }}
    </button>
    }
  </mat-menu>

  <span class="date-picker-header-label">{{ periodLabel() }}</span>

  <button
    mat-button
    #yearTrigger="matMenuTrigger"
    [matMenuTriggerFor]="year"
    (menuOpened)="onYearMenuOpened()"
    class="year-trigger"
  >
    {{ getActiveYear() }}

    <mat-icon matSuffix>arrow_drop_down</mat-icon>
  </button>
  <mat-menu #year="matMenu" class="year-menu" yPosition="below" xPosition="before">
    @for(year of getYears(); track year) {
    <button mat-menu-item (click)="setYear(year)" [class.active]="year === getActiveYear()">
      {{ year }}
    </button>
    }
  </mat-menu>
</div>
